import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AclRoute, ClientAclKeys, withPermission } from '@/lib/acl';

/**
 * Segment layout for `/clients` — gates the whole subtree (listing + detail +
 * future children) behind `clients:listing:read` via a single gated Outlet. (ENT-89 T15.)
 */
export const Route = createFileRoute('/clients')({
  component: withPermission(Outlet, {
    key: ClientAclKeys.listingRead,
    route: AclRoute.CLIENT,
    resourceLabel: 'Clients',
  }),
});
